import { render, staticRenderFns } from "./CandidatesReservePage.vue.vue?vue&type=template&id=09f6ef87&scoped=true&lang=pug"
import script from "./CandidatesReservePage.vue.vue?vue&type=script&lang=js"
export * from "./CandidatesReservePage.vue.vue?vue&type=script&lang=js"
import style0 from "./CandidatesReservePage.vue.vue?vue&type=style&index=0&id=09f6ef87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f6ef87",
  null
  
)

export default component.exports